import React from "react";
import Page from "./page";
import firebase from 'firebase/app';
import 'firebase/firestore';
import PaymentService from "../services/payments_service";
import swal from "sweetalert";

class PaymentMethods extends React.Component {
    state: { payments: firebase.firestore.QueryDocumentSnapshot[] } = {
        payments: null
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        await new PaymentService().getPayments().then(response => {
            this.setState({
                payments: response.docs
            })
        });
    }

    renderPayment(id: string, documentData: firebase.firestore.DocumentData): JSX.Element {
        const isActive = documentData.isActive || false;
        return (
            <div
                className="card"
                style={{ padding: 10, display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}
                onClick={async () => {
                    const response = await swal({
                        title: "Cuidado!",
                        text: "¿Estás segur@ de cambiar el estado a: " + (isActive ? "Desactivado" : "Activado") + "?",
                        buttons: ["Si, Cambiar", "No, Cerrar"]
                    });

                    if (response === null) {
                        swal("Cargando ...");
                        await new PaymentService().updatePayment(id, !isActive);
                        this.setState({ payments: null })
                        await this.getData();
                        swal.close();
                    }
                }}
            >
                <p>{documentData.title}</p>
                <input type="checkbox" defaultChecked={isActive}/>
            </div>
        );
    }

    render() {

        if (this.state.payments === null) {
            return (
                <progress className="progress is-large is-info" max="100" style={{
                    width: "60%",
                    margin: "auto"
                }} />
            );
        }

        return (
            <Page>
                <div style={{ padding: 15 }}>
                <h1 className="title">
                    Metodos de Pago
                </h1>
                {
                    this.state.payments.map<JSX.Element>(payment => {
                        return this.renderPayment(payment.id, payment.data());
                    })
                }
                </div>
            </Page>
        );
    }
}

export default PaymentMethods;